import Immutable from "immutable"
import { CLEAR_BUS_WAIT_TIME_VIOLATIONS, FLAG_GETTING_BUS_WAIT_TIME_VIOLATIONS, GET_BUS_WAIT_TIME_VIOLATIONS } from "../../../actions/types"
import { COLLECTION_SHAPE } from "../../../config/shapes"

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
})


export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case FLAG_GETTING_BUS_WAIT_TIME_VIOLATIONS:
      return state.setIn(['all', 'loading'], payload)
    case GET_BUS_WAIT_TIME_VIOLATIONS:
      return state.setIn(['all', 'content'], Immutable.Map(payload))
    case CLEAR_BUS_WAIT_TIME_VIOLATIONS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      )
    default:
      return state
  }
}